import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const BlockSectionContainer = ({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<"div">) => (
  <div
    className={classNames("wb-mx-auto wb-max-w-7xl", className)}
    {...rest}
    data-block-container
  >
    {children}
  </div>
);

BlockSectionContainer.displayName = "BlockSectionContainer";
